import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-[#F0EBE3] px-6 py-16 md:py-24 flex justify-center" data-id="element-208">
      <div className="max-w-2xl w-full bg-[#FAF8F5] rounded-2xl p-8 md:p-12 shadow-sm border border-[#B8A99A]/20" data-id="element-209">
        <h2 className="font-['DM_Sans'] text-3xl md:text-4xl font-medium text-[#3A3A3A] mb-6 text-center" data-id="element-210">
          You love the cards. <br className="hidden md:block" data-id="element-211" />
          You hate the clutter.
        </h2>

        <p className="text-lg text-[#3A3A3A]/80 leading-relaxed text-center" data-id="element-212">
          Every year, beautiful holiday cards arrive—family photos, handwritten
          notes, updates from friends. You save them in a drawer, a box, or a
          stack on the counter. But eventually, they pile up. And throwing them
          away feels wrong.
        </p>
      </div>
    </section>;
}